import {Component} from '@angular/core';
import { AuthenticationService } from '../../services/authentication.service';
import { ResidentService } from '../../services/resident.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import {ParcelsService} from '../../services/parcels.service';
import {Router} from '@angular/router';

@Component({
    selector: 'basic',
    templateUrl: 'basic.component.html',
    styleUrls: ['basic.component.scss']
})
export class BasicLayoutComponent {

    constructor(
        public authenticationService: AuthenticationService,
        public residentService: ResidentService,
        public parcelsService: ParcelsService,
        private _sanitizer: DomSanitizer,
        public router: Router
    ) {}

    getBackground(image) {
        if(image) {
            return this._sanitizer.bypassSecurityTrustStyle(`url(${image})`);
        }
    }

    showParcelPickup() {
        if(!this.authenticationService.userIsResident)
            this.parcelsService.isEnterParcelBarcodeModalShow = true;
    }
}



// WEBPACK FOOTER //
// /app/src/app/layouts/basic/basic.component.ts